/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.models
{
    export class GisDatastoreQueryConfigurationModel {
        public mapConfiguration:Wars.Domain.Model.Gis.MapConfiguration;
        public currentQuery:Wars.Domain.Model.Gis.GisDatastoreQueryConfiguration;
        public selectedGisDatastore: Wars.Domain.Model.Gis.GisDatastore;
        public gisDatastores:Wars.Domain.Model.Gis.GisDatastore[];

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private deleteService: services.DeleteService,
            private $q: angular.IQService,
            private esriMapService:services.EsriMapService,
            private gisDatastoreService:services.GisDatastoreService,
            private mapConfigurationId:string) {

            mapConfigurationService.getMapConfiguration(mapConfigurationId).then(m => {
                this.mapConfiguration = m;
            });

            gisDatastoreService.getGisDatastores().then(g => {
                this.gisDatastores = g;
            });

        }

        public addQuery() {
            this.currentQuery = this.mapConfigurationService.createGisDatastoreQueryConfiguration();
            this.currentQuery.gisDatastore = this.selectedGisDatastore;
            this.currentQuery.includeGeometryFilter = false;
            this.currentQuery.name = "New Query";

            this.mapConfiguration.gisDatastoreQueryConfigurations.push(this.currentQuery);

            this.save();
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public geometryFilterChanged() {
            if (this.currentQuery.includeGeometryFilter && !this.currentQuery.geometryFilter) {
                this.currentQuery.geometryFilter = this.mapConfigurationService.createGeometryFilter();
                this.currentQuery.geometryFilter.geometryComparisionType = Wars.Domain.Model.Codes.Enums
                    .GeometryComparisionType.EnvelopeIntersects;
                this.currentQuery.geometryFilter.useMapGeometry = false;
                this.currentQuery.geometryFilter.bufferFactor=0;
            }

            this.save();
        }
    }
}